import { Stack } from '../../Stack';
import React from 'react';
import { ShimmerLoader } from '..';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GradientShimmerLoader = props => {
  const renderShimmers = () => {
    const shimmersCount = props.shimmersCount || 3;
    const shimmers = [];
    for (let i = 0; i < shimmersCount; i++) {
      const shimmer = /*#__PURE__*/_jsx(Stack, {
        styles: {
          root: {
            paddingBottom: 8
          }
        },
        children: /*#__PURE__*/_jsx(ShimmerLoader, {
          withLabel: props.withLabel,
          isLoading: props.isLoading,
          height: !props.withLabel ? 19 : undefined
        })
      }, "shimmer-".concat(i));
      shimmers.push(shimmer);
    }
    return shimmers;
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsx(Stack, {
      "data-id": 'gradient-shimmer-loader',
      styles: {
        root: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          padding: 0,
          zIndex: 999999,
          boxSizing: 'border-box',
          display: 'flex',
          right: 0,
          left: 0,
          bottom: 0,
          top: 0,
          backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));'
        }
      }
    }), /*#__PURE__*/_jsx(Stack, {
      children: renderShimmers()
    })]
  });
};